import { getCouponAdjustedSubtotal } from '@app/components/Costs';
import { useCartAndDeliveryDatesDataContext } from '@app/data/clients/cartCheckoutClient';
import { ExperimentConfig } from '@redbubble/next-amplitude';
import { useAmplitudeExperiment } from '@redbubble/next-provider/amplitude';
import { PageHeading } from './PageHeading';
import { PageHeadingSkeleton } from './PageHeadingSkeleton';

export const MonolithCartPageHeadingContainer = () => {
  const { cart, cartLoading } = useCartAndDeliveryDatesDataContext();
  const showSubtotalOnly =
    useAmplitudeExperiment(ExperimentConfig.CartShippingRemoval) ===
    'treatment';
  if (cartLoading) return <PageHeadingSkeleton />;

  if (!cart) return null;

  const { currency, summary, total_items_count } = cart;

  const totalAmount = showSubtotalOnly
    ? getCouponAdjustedSubtotal(cart)
    : summary.total;
  const total = {
    amount: totalAmount,
    currency: currency,
  };
  return <PageHeading lineItemsCount={total_items_count} total={total} />;
};
